import React from "react";
import routeGuard from "src/HOC/routeGuard";
import RocketModelList, {
} from "src/components/RocketModel/list";
import { RESOURCE_TYPE } from "src/constant/common";

const RocketModel = () => {

  return (
    <RocketModelList
    />
  );
};

export default routeGuard(RocketModel, RESOURCE_TYPE.LABOR_SAVING);